import { graphql } from "gatsby";
// import { GatsbySeo } from "gatsby-plugin-next-seo"
// import { useAuth } from "../context/AuthContext";
import React from "react";
import Layout from "../components/common/Layout";
import HeroBanner from "../components/blocks/HeroBanner";
import TitleTextButton from "../components/blocks/TitleTextButton";
import FlexBoxes from "../components/blocks/FlexBoxes";
import Video from "../components/blocks/Video";
import OurVision from "../components/blocks/OurVision";
import Seo from "../components/meta/Seo";

export default function homepageTemplate({ data }) {
  const { Components, locale } = data.page;
  // console.log(data);
  // const { currentLanguage } = useAuth();

  return (
    <Layout pageData={data.page} locale={locale}>
      {/* <Seo page={data?.page} curPage="homepage" pageType={"page"} /> */}
      {Components?.map((block) => {
        switch (block.strapi_component) {
          case "common.hero-banner":
            return <HeroBanner block={block} key={block.strapi_component} />;
          case "common.title-text-button":
            return <TitleTextButton block={block} key={block.id} />;
          case "common.flex-boxes":
            return <FlexBoxes block={block} key={block.id} />;
          case "common.video":
            return <Video block={block} key={block.id} />;
          case "common.our-vision":
            return <OurVision block={block} key={block.id} />;
          default:
            return null;
        }
      })}
    </Layout>
  );
}

export const query = graphql`
  query homepageQuery {
    page: strapiHomepage {
      locale
      localizations {
        data {
          attributes {
            locale
            # slug
          }
        }
      }
      Components {
        ... on STRAPI__COMPONENT_COMMON_HERO_BANNER {
          id
          strapi_component
          backgroundColor
          title
          overlay
          imageMobile {
            url
            localFile {
              url
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED)
              }
            }
          }
          image {
            url
            localFile {
              url
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED)
              }
            }
          }
        }
        ... on STRAPI__COMPONENT_COMMON_TITLE_TEXT_BUTTON {
          id
          strapi_component
          title
          description {
            data {
              childMarkdownRemark {
                html
              }
            }
          }
        }
        ... on STRAPI__COMPONENT_COMMON_FLEX_BOXES {
          id
          strapi_component
          backgroundImage {
            localFile {
              publicURL
            }
          }
          backgroundImagePosition
          backgroundImageSize
          containerFluid
          textAlign
          boxBackgroundColor
          box {
            icon {
              url
              localFile {
                publicURL
              }
            }
            text
          }
          buttonLabel
          description {
            data {
              childMarkdownRemark {
                html
              }
            }
          }
        }
        ... on STRAPI__COMPONENT_COMMON_VIDEO {
          id
          strapi_component
          videoUrlEmbed
          videoEmbedCode {
            data {
              videoEmbedCode
            }
          }
        }
        ... on STRAPI__COMPONENT_COMMON_OUR_VISION {
          id
          backgroundColor
          strapi_component
          title
          subtitle {
            data {
              subtitle
            }
          }
          textLeftCol {
            data {
              childMarkdownRemark {
                html
              }
            }
          }
          bigImage {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED)
              }
            }
          }
          firstImage {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED)
              }
            }
          }
          secondImage {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED)
              }
            }
          }
          bigImageMobile {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED)
              }
            }
          }
          firstImageMobile {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED)
              }
            }
          }
          secondImageMobile {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED)
              }
            }
          }
        }
      }
    }
  }
`;
